import PropTypes from 'prop-types'
import React, { useEffect, useState, useCallback } from 'react'
import { PreviewIframe, PreviewWrapper } from './style'
import Modal from 'Rentlio/components/Modal'
import Animation from 'Rentlio/components/UI/Animation'
import { modals } from 'Rentlio/screen/layout/utils/modalsEnum'
import { breakpoint as responsive, device } from 'Rentlio/style/responsive'

const Modal3DS = ({
  closeModal,
  activeModal,
  modalData,
  callBookReservationApi,
  updateErrorMessage,
  onM2PayPaymentFailed
}) => {
  const mediaMatchQuery = window.matchMedia(device.laptop)
  const [content, setContent] = useState('')
  const [isMobile, setIsMobile] = useState(window.innerWidth <= responsive.laptop)

  useEffect(() => {
    const queryParameters = new URLSearchParams({
      ...modalData
    }).toString()
    setContent(`/api/payment/m2pay/preauth?${queryParameters}`)
    setupSuccessFailureEvents()

    // check if we are on mobile
    checkMediaWidth(mediaMatchQuery)
    // NOTE: Backward compatibility for older version of safari (13 etc. - chrome and firefox are ok here) - don't remove !
    // Please be aware that the MediaQueryList.addListener() method has been deprecated.
    // https://www.w3.org/TR/cssom-view-1/#mediaquerylist
    if (mediaMatchQuery?.addEventListener) {
      mediaMatchQuery.addEventListener('change', checkMediaWidth)
    } else {
      mediaMatchQuery.addListener(checkMediaWidth)
    }

    return () => {
      // Anything in here is fired on component unmount
      removeEventListeners()
      // remove media query listeners
      if (mediaMatchQuery?.addEventListener) {
        mediaMatchQuery.removeEventListener('change', checkMediaWidth)
      } else {
        mediaMatchQuery.removeListener(checkMediaWidth)
      }
    }
  }, [])

  const setupSuccessFailureEvents = () => {
    document.addEventListener('m2paySuccessEvent', handleM2PaySuccessEvent, false)
    document.addEventListener('m2payFailureEvent', handleM2PayErrorEvent, false)
  }

  const handleM2PaySuccessEvent = useCallback(event => {
    callBookReservationApi(modalData.guestDetails, {
      ...modalData.paymentDetails,
      maskedPan: event.detail?.cardNumberMask,
      name: event.detail?.customerName,
      m2payXref: event.detail?.xref
    })
    closeModal()
  }, [])

  const handleM2PayErrorEvent = useCallback(event => {
    onM2PayPaymentFailed()
    updateErrorMessage(event?.detail?.responseMessage || 'Card authorisation error')
    closeModal()
  }, [])

  const removeEventListeners = () => {
    document.removeEventListener('m2paySuccessEvent', handleM2PaySuccessEvent)
    document.removeEventListener('m2payFailureEvent', handleM2PayErrorEvent)
  }

  const checkMediaWidth = (matchQuery = mediaMatchQuery) => {
    if (matchQuery.matches) {
      return setIsMobile(true)
    }
    setIsMobile(false)
  }

  const cancelAndCloseModal = () => {
    onM2PayPaymentFailed()
    removeEventListeners()
    closeModal()
  }

  return (
    <Animation show={activeModal === modals.M2PAY_3DS} animationType={'fadeInOut'} isModal>
      <Modal
        hideModalHandler={cancelAndCloseModal}
        show={activeModal === modals.M2PAY_3DS}
        padding={isMobile ? '0px 50px 0px 0px' : '10px 10px 0px 15px'}
        paddingBottom={'0px'}
        width={450}
      >
        <PreviewWrapper>{content && <PreviewIframe src={content} width='420px' height='430px' />}</PreviewWrapper>
      </Modal>
    </Animation>
  )
}

Modal3DS.propTypes = {
  closeModal: PropTypes.func,
  activeModal: PropTypes.string,
  modalData: PropTypes.object,
  callBookReservationApi: PropTypes.func,
  updateErrorMessage: PropTypes.func,
  onM2PayPaymentFailed: PropTypes.func
}

export default Modal3DS
